import { makeStyles } from "@material-ui/core";

export const issueTrackerConfigStyles = makeStyles(theme => ({
    configsContainer: {
        margin: '1em 0 1em 0'
    },
    lotName: {
        fontWeight: 'bold',
        padding: '1em 0',
        fontSize: '1.2em'
    },
    ruleWrapper: {
    },
    iconsWrapper: {
        alignItems: "center",
        display: 'flex',
        justifyContent: "flex-end"
    },
    iconWrapper: {
        backgroundColor: theme.palette.primary.light,
        height: '50px',
        width: '40px',
        borderRadius: '2px',
        '& fieldset': {
            border: 'none'
        },
        boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.15)",
        padding: 7
    },
    titleWrapper: {
        marginBottom: '1em',
        display: 'flex',
        justifyContent: "space-between",
        alignItems: "center"
    },
    title: {
        fontWeight: 'bold',
        fontSize: '1.2em',
    },
    btnContainer: {
        display: "flex",
        justifyContent: "flex-end",
        backgroundColor: theme.palette.common.white,
    },
    button: {
        margin: "5px",
    },
    listItemWrapper: {
        margin: '1em 0',
        border: '1px solid rgb(113, 186, 242)',
        boxShadow: 'none',
        padding: '2em 2em 1em 2em',
    },
    paramWrapper: {
        padding: '2em'
    },
    listItemWrapperNew: {
        borderColor: '#90C534',
        position: 'relative',
        "&::before": {
            content: "'NEW'",
            color: 'white',
            background: '#90C534',
            position: "absolute",
            fontSize: '0.8em',
            padding: '1px 5px',
            top: '-0.2em',
            left: "1em",
            borderRadius: '4px',
            transform: "translate(0px, -50%)",
        },
    },
    lotContainer: {
        padding: '1em'
    },
    lotMultiSelect: {
        width: '400px',
        flexWrap: 'wrap',
        display: 'flex',
        marginBottom: '1em'
    },
    addButton: {
        margin: "0.5rem 0 0 0",
    },
    conditionsTitle: {
        color: theme.palette.primary.main,
        fontSize: '1.1em',
        margin: '1em 0 1em 0.5rem',
        fontWeight: '500'
    },
    headerContainer: {
        padding: '0 1em',
    },
    warningMessage: {
        margin: '0.3rem 3.5rem 0.7rem 0'
    }
}));